import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TestGroup } from '../pages/orders/modules/order/models/test-group.modal';

@Injectable({ providedIn: 'root' })
export class TestGroupsApiService {
  private readonly httpClient = inject(HttpClient);

  private readonly baseUrl = environment.apiUrl;

  public getFavoriteTestGroups(practiceId: number, laboratoryFacilityId: number): Observable<TestGroup[]> {
    return this.httpClient.get<TestGroup[]>(
      `${this.baseUrl}/test-groups/favorites?practiceId=${practiceId}&laboratoryFacilityId=${laboratoryFacilityId}`
    );
  }
}
